import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pagination({ 
  currentPage, 
  lastPage, 
  perPage, 
  total, 
  onPageChange 
}) {
  console.log('Pagination component props:', { currentPage, lastPage, perPage, total });

  const handlePageChange = (page) => {
    if (page >= 1 && page <= lastPage && page !== currentPage) {
      onPageChange(page);
    }
  };

  // Always show pagination, even if only 1 page
  // if (lastPage <= 1) {
  //   return null;
  // }

  // Generate page numbers to show (similar to the design)
  const getPageNumbers = () => {
    const pages = [];
    
    // Always show first page
    pages.push(1);
    
    // Show current page and adjacent pages
    if (currentPage > 3) {
      pages.push('...');
    }
    
    // Show pages around current page
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(lastPage - 1, currentPage + 1); i++) {
      if (!pages.includes(i)) {
        pages.push(i);
      }
    }
    
    // Show ellipsis before last page if needed
    if (currentPage < lastPage - 2) {
      pages.push('...');
    }
    
    // Always show last page (if more than 1 page)
    if (lastPage > 1 && !pages.includes(lastPage)) {
      pages.push(lastPage);
    }
    
    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="flex items-center justify-center py-8">
      <div className="flex items-center bg-secondary border border-secondary-border rounded-lg px-2 py-2">
        {/* Back Button */}
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="flex items-center space-x-2 px-4 py-3 text-foreground hover:text-primary disabled:opacity-30 disabled:cursor-not-allowed transition-colors font-medium rounded-lg hover:bg-secondary/50"
        >
          <ChevronLeft size={16} />
          <span className="text-sm">Back</span>
        </button>

        {/* Page Numbers */}
        <div className="flex items-center space-x-1 mx-2">
          {pageNumbers.map((page, index) => {
            if (page === '...') {
              return (
                <span key={`ellipsis-${index}`} className="px-3 py-3 text-muted-foreground text-sm font-medium">
                  ...
                </span>
              );
            }
            
            return (
              <button
                key={page}
                onClick={() => handlePageChange(page)}
                className={`min-w-[44px] h-11 px-3 rounded-lg text-sm font-semibold transition-colors ${
                  page === currentPage
                    ? 'bg-primary text-white'
                    : 'text-foreground hover:bg-secondary/50 hover:text-primary'
                }`}
              >
                {page}
              </button>
            );
          })}
        </div>

        {/* Next Button */}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === lastPage}
          className="flex items-center space-x-2 px-4 py-3 text-foreground hover:text-primary disabled:opacity-30 disabled:cursor-not-allowed transition-colors font-medium rounded-lg hover:bg-secondary/50"
        >
          <span className="text-sm">Next</span>
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
} 